//
import type { IPolicyStore } from './policyStore.model';

// TODO: the default policies array shouldd be empty
export const getDefaultState = (): IPolicyStore => ({
  step: -1,
  loading: {
    payment: false,
    policy: false,
    ach: false,
  },
  navHintDismissed: true,
  selectedPolicyIndex: 0,
  paymentPanel: [
    {
      contractId: 0,
      editPayments: {
        paymentMethodChangeAlert: false,
        editPaymentMethod: false,
        disablePaymentDetailsLink: false,
      },
      panelValue: -1,
    },
  ],
  policies: [
    {
      contractId: '0',
      policyData: {
        owner: {
          name: '',
          phone: '',
          email: '',
          address: {
            line1: '',
            line2: '',
            city: '',
            state: '',
            zip: '',
            phone: '',
          },
        },
        paymentInfo: {
          premium: '',
          paidToDate: '',
          method: '',
          draftDate: '',
        },
        details: {
          primaryInsured: '',
          status: '',
          insured: [
            {
              dateOfBirth: '',
              issueDate: '',
              sex: '',
              issueAge: '',
              planType: '',
              planDescription: '',
              underwritingClass: '',
              benefitAmount: '',
              name: '',
            },
          ],
          annuity: {
            value: '',
            type: '',
            description: '',
            issueDate: '',
          },
        },
        totalCoverageAmount: 0,
        bank: {
          accountNumber: '',
          payorName: '',
          bankName: '',
        },
      },
      paymentInfo: {
        accountName: '',
        accountNumber: '',
        accountType: '',
        autoDraftPaymentDate: '',
        billForm: '',
        billMode: '',
        billToDate: '',
        errorMessage: '',
        modePremiumAmount: '',
        newPremiumAmount: '',
        nextCycleDate: '',
        paidToDate: '',
        policyNumber: '',
        policyRecordID: '',
        policyStatus: '',
        restrictCode: '',
        returnCode: '',
        routingNumber: '',
        suspendCode: '',
        minimumPaymentAmount: 0.0,
        annualPremium: 0.0,
        monthlyPremium: 0.0,
        quarterlyPremium: 0.0,
        semiAnnualPremium: 0.0,
        totalPaymentAmount: 0.0,
        isSavingsAccount: false,
        payInProcess: false,
        bank: {
          account: '',
          name: '',
          payorName: '',
        },
      },
      paynowInfo: {
        totalPaymentAmount: 0.0,
        minimumPaymentAmount: 0.0,
        inSufficientFunds: false,
        hasAnnuity: false,
        hasMultipleOptions: false,
        isPastDue: false,
        isPTDFuture: false,
        pastDueAmount: '0.00',
        pastDueAmountPlusPac: '0.00',
        pastDueDays: 0,
      },
      billingMode: '01',
      billingForm: 'A1',
      showPayNowLink: false,
      payNowLinkDesc: '',
      kubraPaymentStatus: null,
      activePrimaryCoverage: 0.0,
      activeSpouseCoverage: 0.0,
      active: true,
      pending: false,
      restricted: false,
      status: '',
      agentId: '',
      restrictCode: '',
      reinstatement: undefined,
      showAddChildLink: false,
      statusText: '',
      servicingAgent: undefined,
      servicingRVP: undefined,
    },
  ],
  successResponseUpdateContactInfo: [],
  errorResponseUpdateContactInfo: [],
  addressVerification: undefined,
  addressUpdateSuccess: false,
  base64String: null,
  contactDetailsPanel: -1,
  editContactInfo: false,
  bankName: null,
  paymentData: {
    amount: '',
    paymentType: '',
    accountType: '',
    accountCode: '',
    accountHolder: '',
    routingNumber: '',
    accountNumber: '',
    bankName: '',
  },
  restrictedPolicy: false,
  showPayNowInfoCard: false,
  paymentInfoShowPaymentAmountDateBillingMethod: true,
  payNowLinkToggle: true,
  updatingBank: false,
  preLoadBank: null,
  beneficiaries: [],
  beneficiaryStep: -1,
  beneficiaryPrimary: [],
  beneficiaryPrimaryContingent: [],
  beneficiarySpouse: [],
  beneficiarySpouseContingent: [],
  isBeneficiaryDataDirty: false,
  paymentStep: -1,
  routeNameToNavigateBack: '',
  hasTerminatedPolicies: undefined,
  terminatedPolicyAgent: null,
  scrollToPolicyDetails: 'policy-panel',
  withDrawalDateStep: -1,
  changeBankAccountStep: -1,
  payMethodChange: -1,
});

const state = getDefaultState();

export default state;
